import { FormArray, ValidationErrors } from '@angular/forms';

export function ArrayMinLengthValidator(minLength: number) {
    return function(formArray: FormArray): ValidationErrors | null {
      return formArray.length < minLength ?  { arrayMinLength: true } : null;
    };
};